import { USER_RESOURCES_QUERY_KEY } from '@hotjar/user-resources';
import { webappQueryClient } from '~/subscription-management/external-dependencies/webapp-utils';

export const invalidateCacheOnSuccess = async (): Promise<void> => {
  /**
   * we need to be able to access the latest plans on resources let's clear the cache on all queries
   */
  await webappQueryClient.invalidateQueries(USER_RESOURCES_QUERY_KEY);
};
